import React from 'react';
import ReactDOM from 'react-dom';
import { motion, AnimatePresence } from 'framer-motion';
import './LogoutConfirmDialog.css';

export const LogoutConfirmDialog = ({ open, onPause, onLogout, onRunInSpirit, closeDialog, onCancel }) => {
  const [loading, setLoading] = React.useState(false);
  if (!open) return null;

  return ReactDOM.createPortal(
    <AnimatePresence mode="sync">
      {open && (
        <motion.div
          className="lcd-overlay"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <motion.div
            className="lcd-dialog"
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            transition={{ duration: 0.15 }}
          >
            <button className="lcd-close" onClick={onCancel} aria-label="Close">×</button>
            <h3 className="lcd-title">Pause campaigns before logging out?</h3>
            <p className="lcd-message">
              Your outreach campaigns will keep running in the cloud. You can pause them now or simply close this dialog.
            </p>
            <div className="lcd-buttons">
              <button
              className="lcd-btn"
              onClick={async () => {
                if (loading) return;
                try {
                  setLoading(true);
                  await onPause();
                  await onLogout();
                  closeDialog();
                } finally {
                  setLoading(false);
                }
              }}
              disabled={loading}
            >
              {loading ? (
                <span className="spinner" />
              ) : (
                'Pause \u0026 Logout'
              )}
            </button>
              <button
                className="lcd-btn lcd-secondary"
                onClick={() => {
                  (onRunInSpirit || onLogout)();
                  closeDialog();
                }}
              >
                Run in Stealth
              </button>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>,
    document.body
  );
};
